__turbopack_context__.v({
  "button": "YZvYLa_button",
  "buttonContainer": "YZvYLa_buttonContainer",
  "container": "YZvYLa_container",
  "explore": "YZvYLa_explore",
  "nav": "YZvYLa_nav",
  "navItem": "YZvYLa_navItem",
  "navItemContent": "YZvYLa_navItemContent",
  "navItemIcon": "YZvYLa_navItemIcon",
  "navItemText": "YZvYLa_navItemText",
  "navItems": "YZvYLa_navItems",
  "noDropdown": "YZvYLa_noDropdown",
  "open": "YZvYLa_open",
  "secondaryButton": "YZvYLa_secondaryButton",
  "submenu": "YZvYLa_submenu",
  "submenuBack": "YZvYLa_submenuBack",
  "submenuBackIcon": "YZvYLa_submenuBackIcon",
  "submenuBackText": "YZvYLa_submenuBackText",
  "submenuGroupTitle": "YZvYLa_submenuGroupTitle",
  "submenuLink": "YZvYLa_submenuLink",
  "submenuLinks": "YZvYLa_submenuLinks",
  "submenuLinksContainer": "YZvYLa_submenuLinksContainer",
  "submenuOpen": "YZvYLa_submenuOpen",
  "userIcon": "YZvYLa_userIcon",
});
